import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/comics";

const values = [
  {
    icon: "ri-customer-service-2-line",
    title: "读者第一",
    desc: "每一次产品迭代，都以读者的阅读体验为出发点。",
    color: "bg-primary-100 text-primary-800",
  },
  {
    icon: "ri-leaf-line",
    title: "内容纯粹",
    desc: "坚持内容质量为王，只推荐真正好看、值得追的漫画。",
    color: "bg-accent-100 text-accent-800",
  },
  {
    icon: "ri-sailboat-line",
    title: "陪伴成长",
    desc: "与你一起追更、一起分享，做长期陪伴的阅读伙伴。",
    color: "bg-secondary-100 text-secondary-800",
  },
];

const stats = [
  { num: "5000+", label: "在线漫画作品" },
  { num: "120万+", label: "活跃读者" },
  { num: "24h", label: "每日更新不停" },
  { num: "99.9%", label: "读者满意度" },
];

export default function About() {
  return (
    <div>
      <section className="bg-background-100 py-8">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-foreground-500">
            <Link to="/" className="hover:text-primary-700">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <div className="mt-4 max-w-2xl">
            <h1 className="font-heading text-3xl text-foreground-950 md:text-4xl">关于新新漫画网</h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              新新漫画网是一个面向中文读者的在线漫画阅读平台。我们相信，好的阅读工具应该足够贴心——收藏、订阅、离线、历史记录与个性化推荐，让每一次追更都更顺手。
            </p>
          </div>
        </div>
      </section>

      {/* 品牌介绍 */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <SectionHeading
              eyebrow="我们的故事"
              title="为热爱漫画的你，做一个更顺手的阅读平台"
            />
            <p className="mt-5 text-sm leading-relaxed text-foreground-600">
              新新漫画网的初衷很简单：把「追更」这件小事做到极致。我们调研了大量漫画读者的习惯，发现大家最在意的往往是——
              喜欢的作品能否快速收藏、更新能否及时提醒、没网时能否照常阅读、换设备时进度会不会丢。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              于是，我们围绕这五个核心诉求，打磨出书架收藏、更新订阅、离线缓存、历史记录与个性化推荐五大功能，希望让你把精力留给故事本身，而不是繁琐的操作。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/features"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
              >
                了解阅读功能
              </Link>
              <Link
                to="/ranking"
                className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition hover:border-primary-300"
              >
                去看看漫画
              </Link>
            </div>
          </div>
          <div className="w-full">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20illustration%20of%20a%20team%20of%20illustrators%20and%20developers%20working%20around%20a%20table%20with%20comic%20storyboards%2C%20laptops%20and%20coffee%2C%20warm%20coral%20and%20teal%20palette%2C%20flat%20vector%20style%2C%20clean%20background&width=1000&height=720&seq=about-team&orientation=landscape"
              alt="新新漫画网团队工作场景图"
              className="w-full rounded-lg border border-background-200/70 object-cover"
            />
          </div>
        </div>
      </section>

      {/* 数据 */}
      <section className="bg-primary-500 py-10">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 md:grid-cols-4 md:px-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-heading text-3xl text-background-50 md:text-4xl">{s.num}</div>
              <div className="mt-1 text-sm text-primary-100">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* 定位与理念 */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-compass-3-line text-2xl"></i>
            </span>
            <h2 className="mt-4 font-heading text-xl text-foreground-950">网站定位</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              新新漫画网定位于「个性化的漫画阅读工具 + 优质内容门户」。我们不止提供海量漫画，更通过收藏、订阅、离线、历史与推荐，帮每位读者建立属于自己的追更节奏与阅读空间。
            </p>
          </div>
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
              <i className="ri-lightbulb-flash-line text-2xl"></i>
            </span>
            <h2 className="mt-4 font-heading text-xl text-foreground-950">发展理念</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们信奉「把简单留给读者，把复杂留给自己」。平台持续迭代，只为了让追更更顺手、看书更自在。每一处细节的打磨，都是对读者的尊重。
            </p>
          </div>
        </div>

        <div className="mt-8">
          <SectionHeading center eyebrow="内容原则" title="我们坚持的三件事" />
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {values.map((v) => (
              <div
                key={v.title}
                className="rounded-lg border border-background-200/70 bg-background-50 p-6 text-center"
              >
                <span className={`mx-auto flex h-12 w-12 items-center justify-center rounded-lg ${v.color}`}>
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 口碑 */}
      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <SectionHeading center eyebrow="读者口碑" title="来自读者的真实反馈" />
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5"
              >
                <blockquote className="flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={`${t.name}头像`}
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-bold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* 联系方式 */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <SectionHeading eyebrow="联系我们" title="任何问题，都欢迎来找我们" />
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于网站功能、漫画内容或使用上的任何疑问，都可以通过以下方式与我们联系。我们会尽快回复每一位读者。
            </p>
          </div>
          <ul className="flex flex-col gap-3">
            <li className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-800">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <div>
                <div className="text-sm font-bold text-foreground-950">邮箱</div>
                <div className="text-sm text-foreground-600">service@xinxinmanhua.com</div>
              </div>
            </li>
            <li className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                <i className="ri-question-answer-line text-xl"></i>
              </span>
              <div>
                <div className="text-sm font-bold text-foreground-950">在线客服</div>
                <div className="text-sm text-foreground-600">工作日 9:00 - 21:00 在线</div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}